import { render, staticRenderFns } from "./projectsTransfer.vue?vue&type=template&id=2d267650&"
import script from "./projectsTransfer.vue?vue&type=script&lang=js&"
export * from "./projectsTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports